//
// Autogenerated by Thrift Compiler (0.7.0-en-11139b3b5cb61e817408c6e84b0e1c258bf6c6ae)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;

  module.exports.Result = {
    'SUCCESS' : 1,
    'UNKNOWN_OPENID' : 2,
    'USER_EXISTS' : 3,
    'OPENID_CONFLICT' : 4
  };

  module.exports.ServiceProvider = {
    'GOOGLE' : 0,
    'FACEBOOK' : 1
  };

  module.exports.OpenIdCredential = Thrift.Struct.define('OpenIdCredential',  {
    1: { alias: 'tokenPayload', type: Thrift.Type.STRING },
    2: { alias: 'serviceProvider', type: Thrift.Type.I32 }
  });

  module.exports.PlainCredential = Thrift.Struct.define('PlainCredential',  {
    1: { alias: 'userId', type: Thrift.Type.I32 },
    2: { alias: 'password', type: Thrift.Type.STRING }
  });

  module.exports.AuthenticationRequestResult = Thrift.Struct.define('AuthenticationRequestResult',  {
    1: { alias: 'userId', type: Thrift.Type.I32 },
    2: { alias: 'userEmail', type: Thrift.Type.STRING },
    3: { alias: 'result', type: Thrift.Type.I32 }
  });

  module.exports.RegistrationRequestResult = Thrift.Struct.define('RegistrationRequestResult',  {
    1: { alias: 'refreshToken', type: Thrift.Type.STRING },
    2: { alias: 'userEmail', type: Thrift.Type.STRING },
    3: { alias: 'result', type: Thrift.Type.I32 },
    4: { alias: 'name', type: Thrift.Type.STRING }
  });

